import {
	Directive,
	Input,
	ElementRef,
	HostBinding,
	Renderer2
} from "@angular/core";

@Directive({
    selector: "[mat-button][dodo-simple-button]",
    standalone: false
})
export class DodoSimpleButtonDirective {
	@HostBinding("style.height.px")
	@Input()
	height = 50;

	constructor(er: ElementRef, __renderer: Renderer2) {
		const __element = er.nativeElement;
		__renderer.addClass(__element, "dodo-simple-button");
	}
}
